import { reactive } from 'vue';

export function useAuth() {
  // Load authentication state from localStorage (default is false)
  const authState = reactive({
    isAuthenticated: JSON.parse(localStorage.getItem("isAuthenticated")) || false,
    userName: localStorage.getItem("userName") || null,
    customerId: localStorage.getItem("customerId") || null,
    loginName: localStorage.getItem("loginName") || null,
    loginNumber: localStorage.getItem("loginNumber") || null
  });

  // Function to log in and persist authentication state
  function login(userName, customerId, loginName, loginNumber) {
    authState.isAuthenticated = true;
    authState.userName = userName;
    authState.customerId = customerId;
    authState.loginName = loginName;
    authState.loginNumber = loginNumber;
    localStorage.setItem("isAuthenticated", JSON.stringify(true));
    localStorage.setItem("userName", userName);
    localStorage.setItem("customerId", customerId);
    localStorage.setItem("loginName", loginName);
    localStorage.setItem("loginNumber", loginNumber);
  }

  // Function to log out and remove authentication state
  function logout() {
    authState.isAuthenticated = false;
    authState.userName = null;
    authState.customerId = null;
    authState.loginName = null;
    authState.loginNumber = null;
    localStorage.removeItem("isAuthenticated");
    localStorage.removeItem("userName");
    localStorage.removeItem("customerId");
    localStorage.removeItem("loginName");
    localStorage.removeItem("loginNumber");
  }

  return { authState, login, logout };
}
